import { useEffect } from "react";
import { Grid, Typography, useTheme } from "@mui/material";
import { Footprints } from "lucide-react";
import * as api from "../../../Auth/auth";
import PageProtectedOnboarding from "../../../components/Page/PageProtectedOnboarding";
import { pool } from "../../../constants";
import { useAuth } from "../../../provider";
import { useTranslation } from "../../../language";
import OnbSteps from "../../../components/Steps/OnbSteps";
import ButtonsMainGoTo from "../../../components/Button/ButtonMainGoTo";
import LabVisitConfirmationCard from "./LabVisitConfirmationCard";

export default function LabvisitStep() {
  const { state, handleLogout } = useAuth();
  const { t, changeLanguage } = useTranslation();
  const theme = useTheme();

  useEffect(() => {
    if (state.user?.language) {
      changeLanguage(state.user.language);
    }
  }, [state.user?.language]);

  const handleLogoutapi = async () => {
    const response = await api.logout();
    await handleLogout(response);
  };

  const accentColor = theme.palette.tertiary.C300;

  return (
    <PageProtectedOnboarding
      headerImage={pool}
      brandtext={t("onbsub_brandtext")}
      content={
        <>
          <Grid container sx={{ mb: 5, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Grid size={12} sx={{ width: '100%', maxWidth: 900, px: { xs: 1, sm: 2 }, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <OnbSteps stepNumber={3} />
            </Grid>
          </Grid>

          <Grid container sx={{ mb: 3, justifyContent: 'center' }}>
            <Grid size={{ xs: 12 }} sx={{ maxWidth: 600, mx: 'auto', px: { xs: 2, sm: 0 } }}>
              <Typography variant="body2" color="text.secondary">
                {t("labvisitstep_overline")}
              </Typography>
              <Typography variant="h4" fontWeight={700} sx={{ mb: 2 }}>
                {t("labvisitstep_headline")}
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                {t("labvisitstep_subtitle")}
              </Typography>
            </Grid>
          </Grid>

          <LabVisitConfirmationCard
            beforeConfirm={
              <>
                <Grid container sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                  <Footprints size={32} color={accentColor} />
                </Grid>

                <Grid container sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                  <Grid size={{ xs: 12 }} sx={{ maxWidth: 600, mx: 'auto', px: { xs: 3, sm: 0 } }}>
                    <Typography variant="subtitle2" textAlign="center" sx={{ fontWeight: 400 }}>
                      {t("labvisitstep_logout_text")}
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                  <Grid size={{ xs: 12 }} sx={{ maxWidth: 600, display: 'flex', justifyContent: 'center' }}>
                    <ButtonsMainGoTo name={t("onb_snc_logout")} to="/Login" onClick={handleLogoutapi} />
                  </Grid>
                </Grid>
              </>
            }
          />
        </>
      }
    />
  );
}
